import { createSlice } from '@reduxjs/toolkit';

export const userConfigurationSlice = createSlice({
  name: 'userConfiguration',
  initialState: {
    onBoardingDontShowAgain: false,
    startOnBoarding: true,
    notificationVisibilityCondensed: false,
  },
  reducers: {
    setDontShowAgainOnBoardingAtUserConfig: (state, action) => {
      state.onBoardingDontShowAgain = action.payload;
    },
    setStartOnBoardingAtUserConfig: (state, action) => {
      state.startOnBoarding = action.payload;
    },
    setNotificationVisibilityAtUserConfig: (state, action) => {
      state.notificationVisibilityCondensed = action.payload;
    },
  },
});

export const {
  setDontShowAgainOnBoardingAtUserConfig,
  setStartOnBoardingAtUserConfig,
  setNotificationVisibilityAtUserConfig,
} = userConfigurationSlice.actions;

export const { reducer: userConfigurationReducer } = userConfigurationSlice;
